<div
  *ngIf="musicPlayerService.playerData.list?.length > 0"
  class="wrapPlayer shadow-theme"
  [class.show]="musicPlayerService.playerData.open"
>
  <div (click)="musicPlayerService.showPlayer = !musicPlayerService.playerData.open" class="closePlayer shadow-theme">
    <i-feather name="music" class="icon-lg pointer icon-closed"></i-feather>
    <i-feather name="chevron-down" class="icon-lg pointer icon-opened"></i-feather>
  </div>
  <gs-player
    #wrapPlayer
    [class.has-playlist]="musicPlayerService.msaapDisplayPlayList"
    [files]="musicPlayerService.playerData.list"
    [playerTheme]="musicPlayerService.playerTheme"
  >
  </gs-player>
</div>
